// Shared formatting helpers for the Staffing & Development Tracker module.
import { c } from '../../theme';

export function fmtNumber(n) {
  return Number(n || 0).toLocaleString('en-US');
}

export function fmtPercent(n) {
  return `${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 1 })}%`;
}

export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${+m[2]}/${+m[3]}/${m[1]}`;
  return s;
}

// Driver/Mechanic/Operations/Admin — a consistent color per category across
// every Staffing Tracker table. Four real semantic categories theme.js has
// no tokens for, so each keeps its own hue; Admin leans on the neutral ramp
// since it reads as "no category" as much as a category of its own.
const CATEGORY_COLORS = {
  Driver:     { bg: c.infoTint, color: c.info },
  Mechanic:   { bg: '#FFF7ED', color: '#C2410C' },
  Operations: { bg: '#F5F3FF', color: '#6D28D9' },
  Admin:      { bg: c.canvas, color: c.textStrong },
};
export function categoryColor(category) {
  return CATEGORY_COLORS[category] || { bg: c.canvas, color: c.textMuted };
}

const STATUS_COLORS = {
  Open:  { bg: c.successTint, color: c.successText },
  Offer: { bg: c.warningTint, color: c.warningText },
};
export function statusColor(status) {
  return STATUS_COLORS[status] || { bg: c.canvas, color: c.textMuted };
}
